"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
require("react-dates/initialize");
var _reactDates = require("react-dates");
require("react-dates/lib/css/_datepicker.css");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var PrevIcon = function PrevIcon() {
  return /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-chevron-left glyphicon glyphicon-chevron-left"
  });
};
var NextIcon = function NextIcon() {
  return /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-chevron-right glyphicon glyphicon-chevron-right"
  });
};
var DayPickerSingleDate = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DayPickerSingleDate, _Component);
  var _super = _createSuper(DayPickerSingleDate);
  function DayPickerSingleDate(props) {
    var _this;
    (0, _classCallCheck2.default)(this, DayPickerSingleDate);
    _this = _super.call(this, props);
    _this.state = {
      disablePrev: false,
      selectedDate: props.date
    };
    _this.onPrevMonthClick = _this.onPrevMonthClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.onNextMonthClick = _this.onNextMonthClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.onDateChange = _this.onDateChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onHidePrevMonth = _this.onHidePrevMonth.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(DayPickerSingleDate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.state.selectedDate && (0, _momentTimezone.default)().isSameOrBefore(this.props.minDate, 'month')) {
        this.onHidePrevMonth(true);
      }
      if ((0, _momentTimezone.default)(this.state.selectedDate).isSameOrBefore(this.props.minDate, 'month')) {
        this.onHidePrevMonth(true);
      }
    }
  }, {
    key: "onHidePrevMonth",
    value: function onHidePrevMonth(value) {
      this.setState({
        disablePrev: value
      });
    }
  }, {
    key: "onPrevMonthClick",
    value: function onPrevMonthClick(e) {
      if ((0, _momentTimezone.default)(e).isSameOrBefore(this.props.minDate, 'month')) {
        this.onHidePrevMonth(true);
      }
    }
  }, {
    key: "onNextMonthClick",
    value: function onNextMonthClick(e) {
      if ((0, _momentTimezone.default)(e).isAfter(this.props.minDate, 'month')) {
        this.onHidePrevMonth(false);
      }
    }
  }, {
    key: "onDateChange",
    value: function onDateChange(day) {
      this.setState({
        selectedDate: day
      });
      this.props.onChange(day);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        disablePrev = _this$state.disablePrev,
        selectedDate = _this$state.selectedDate;
      var _this$props = this.props,
        className = _this$props.className,
        isOutsideRange = _this$props.isOutsideRange,
        actionBtn = _this$props.actionBtn,
        locale = _this$props.locale;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(className, " ").concat(disablePrev ? 'hidden-prev-icon' : '', " ")
      }, /*#__PURE__*/_react.default.createElement(_reactDates.DayPickerSingleDateController, {
        date: (0, _momentTimezone.default)(selectedDate).locale(locale),
        focused: true,
        className: "p-l-sm",
        onDateChange: this.onDateChange,
        isOutsideRange: isOutsideRange,
        noBorder: true,
        daySize: 30,
        numberOfMonths: 1,
        transitionDuration: 0,
        monthFormat: "MMMM YYYY",
        hideKeyboardShortcutsPanel: true,
        navPrev: /*#__PURE__*/_react.default.createElement(PrevIcon, null),
        navNext: /*#__PURE__*/_react.default.createElement(NextIcon, null),
        onPrevMonthClick: this.onPrevMonthClick,
        onNextMonthClick: this.onNextMonthClick,
        renderDayContents: function renderDayContents(day) {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "custom-date"
          }, day.date());
        },
        renderMonthElement: function renderMonthElement(_ref) {
          var month = _ref.month;
          return (0, _momentTimezone.default)(month).locale(locale).format('MMMM YYYY');
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "action-calendar-wrapper"
      }, actionBtn));
    }
  }]);
  return DayPickerSingleDate;
}(_react.Component);
DayPickerSingleDate.propTypes = {
  className: _propTypes.default.string,
  date: _propTypes.default.instanceOf(_momentTimezone.default),
  minDate: _propTypes.default.instanceOf(_momentTimezone.default),
  onChange: _propTypes.default.func.isRequired,
  isOutsideRange: _propTypes.default.func.isRequired,
  actionBtn: _propTypes.default.element.isRequired,
  locale: _propTypes.default.string
};
DayPickerSingleDate.defaultProps = {
  className: '',
  minDate: (0, _momentTimezone.default)(),
  date: (0, _momentTimezone.default)(),
  locale: 'en-us'
};
var _default = DayPickerSingleDate;
exports.default = _default;